import { Box, Container } from '@mui/material'
import { useEffect, useState } from 'react'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import ListOperations from './ListOperations'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export const MesProjects = ({
  CreateProjectModal,
  updateTodo = false,
  createProject,
  setProjectTaskId,
  setProjectTaskName,
}) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [mOpen, setMOpen] = useState(false)
  const [operations, setOperations] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  useEffect(() => {
    fetchOperations()
  }, [createProject])

  const fetchOperations = async (pagination = '') => {
    let url = `${urls.projectOperations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkProjectOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        updateTodo()
        console.log('Deleted Successfully')
      }
    }
  }
  return (
    <>
      {mOpen && (
        <CreateMessage
          setMOpen={setMOpen}
          title={t('mesToDo.shareProject')}
          settingId={9}
          project={operations.results.filter((v) => v.id === selectedRows[0])[0]}
        />
      )}
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  setMOpen(true)
                } else {
                  alert(t('mesToDo.selectOneToShareAlert'))
                }
              }}
            >
              {t('mesToDo.share')}
            </CustomButton>
            <CustomButton>{t('mesToDo.hideCompleted')}</CustomButton>
            <CustomButton
              onClick={() => {
                CreateProjectModal()
              }}
            >
              {t('mesToDo.add')}
            </CustomButton>
            <CustomButton onClick={deleteBulkOperations}>{t('mesToDo.delete')}</CustomButton>
          </Box>
        </Box>
        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
          setProjectTaskId={setProjectTaskId}
          setProjectTaskName={setProjectTaskName}
        />
      </Container>
    </>
  )
}
